import Vue from "vue";
import Router from "vue-router";
import mainPage from "./components/mainPage";
import mainHeader from "./components/mainHeader";
import mainFooter from "./components/mainFooter";
import aboutMe from "./components/aboutMe";
import countdown from "./components/project/countdown";

Vue.use(Router);

export default new Router({
    mode:'history',
    routes: [
        {
            path: "/",
            name: "mainPage",
            components: { default: mainPage ,header:mainHeader ,footer:mainFooter},
        },
        {
            path: "/aboutMe",
            name: "aboutMe",
            components: { default: aboutMe ,header:mainHeader ,footer:mainFooter},
        },
        {
            path: "/project/birthdate",
            name: "birthdate",
            components: { default: countdown ,header:mainHeader ,footer:mainFooter}
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});


// WEBPACK FOOTER //
// ./src/router.js